import React, {Fragment, useEffect} from "react";
import {useDispatch} from "react-redux";
import {requestCurrentUser} from "modules/actions/user";
import {IS_PRE_REGISTRATION} from "apps/DRAW_PREDICTOR/modules/constants";

export const Session: React.FC = ({children}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (!IS_PRE_REGISTRATION) {
			dispatch(requestCurrentUser());
		}
	}, [dispatch]);

	return <Fragment>{children}</Fragment>;
};
